import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';
import { getRelevantQuestions } from './filterQuestions';
import { CommaURLSearchParams } from '@/globals/routing/CommaURLSearchParams';
import { useCommaSearchParams } from '@/globals/routing/useCommaSearchParams';
import { useDOPRouter } from '@/globals/routing/DOPRouter';
import { AnyRenderedQuestion, GivenAnswers } from '../_questions/question.types';
import { getQuestionMethods } from '../_questions/getQuestionMethods';
export const convertGivenAnswersToSearchParams = (givenAnswers: GivenAnswers, questions: Array<AnyRenderedQuestion>) => {
  const searchParams = new CommaURLSearchParams();
  const relevantQuestions = getRelevantQuestions(questions, givenAnswers);
  for (const question of relevantQuestions) {
    const {
      addToSearchParams
    } = getQuestionMethods(question.type);
    addToSearchParams({
      searchParamsDraft: searchParams,
      question,
      givenAnswers
    });
  }
  return searchParams;
};
const convertSearchParamsToGivenAnswers = (searchParams: CommaURLSearchParams, questions: Array<AnyRenderedQuestion>) => {
  const givenAnswers: GivenAnswers = {
    single: new Map(),
    multiple: new Map(),
    matrix: new Map()
  };
  for (const question of questions) {
    const {
      addToGivenAnswers
    } = getQuestionMethods(question.type);
    addToGivenAnswers({
      givenAnswersDraft: givenAnswers,
      question,
      searchParams
    });
  }
  return givenAnswers;
};
export const useGivenAnswers = questions => {
  const $ = _c(9);
  const searchParams = useCommaSearchParams();
  const router = useDOPRouter();
  let t0;
  if ($[0] !== questions || $[1] !== searchParams) {
    t0 = convertSearchParamsToGivenAnswers(searchParams, questions);
    $[0] = questions;
    $[1] = searchParams;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const givenAnswers = t0;
  let t1;
  if ($[3] !== questions || $[4] !== router) {
    t1 = newGivenAnswers => {
      const newSearchParams = convertGivenAnswersToSearchParams(newGivenAnswers, questions);
      const searchParamsString = `?${newSearchParams.toString()}`;
      router.replaceClient(searchParamsString);
    };
    $[3] = questions;
    $[4] = router;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const setGivenAnswers = t1;
  let t2;
  if ($[6] !== givenAnswers || $[7] !== setGivenAnswers) {
    t2 = [givenAnswers, setGivenAnswers];
    $[6] = givenAnswers;
    $[7] = setGivenAnswers;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2 as const;
};